export const config = {
  logo: process.env.REACT_APP_LOGO,
  logoWithTitle: process.env.REACT_APP_LOGO,
  primaryColor: process.env.REACT_APP_PRIMARY_COLOR,
  secondaryColor: process.env.REACT_APP_SECONDARY_COLOR,
  bankName: process.env.REACT_APP_NAME,
  footerContactPhone: process.env.REACT_APP_FOOTER_CONTACT_PHONE,
  footerContactEmail: process.env.REACT_APP_FOOTER_CONTACT_EMAIL,
  footerContactAddress: process.env.REACT_APP_FOOTER_CONTACT_ADDRESS,
  footerContactAddress2: process.env.REACT_APP_FOOTER_CONTACT_ADDRESSTWO,
};
